export default __webpack_public_path__ + "static/media/article-preview.41b7c6e2.png";